import angular from 'angular'

/* @ngInject */
function PostsController ($scope, $rootScope, $q, $translate, $stateParams, $state, $location, $timeout, ModalService, ToastService, PostsService, SliderService, AdminService, SegmentService, Utils) {
  $scope.flags = {
    bLoading: true
  }
  $scope.iCurrentTop = 10
  $scope.iPostsCount = 0
  $scope.iTokensCount = $rootScope.isDesktop ? 10 : 5
  $scope.iToken = 0
  $scope.aPosts = []
  $scope.pinnedPosts = []
  $scope.noPinnedPosts = true
  $scope.filters = {}
  $scope.search = ''
  $scope.pathCategory = []
  $scope.skipPagingTo = skipPagingTo
  $scope.selectedCategory = undefined
  $scope.isArchived = false
  $scope.currentPage = 0
  const isAdminOrDesigner = $rootScope.isUserSysAdminAdminDesigner()
  let company

  const api = {
    _successGetPosts,
    _successGetCategories,
    _successGetParentForCategory,
    _getPostsCategories,
    _handleError,
    _getPosts,
    _changeUnreadFlag,
    _keepOnSamePage,
    _checkIfPageExists,
    _onFilter,
    _onSearch,
    _getHeaderRightButtons,
    _initHeader
  }
  this.getApi = () => api

  activate()

  function activate () {
    $timeout(function () {
      if ($stateParams.post && $rootScope.oUser) {
        if ($rootScope.isDesktop) {
          $scope.seePostDetails({ id: Number.parseInt($stateParams.post) })
        } else {
          SliderService.setState('post-slider', 'open', {
            _postId: Number.parseInt($stateParams.post),
            _editMode: false
          })
        }
      }
    }, 1000)

    $rootScope.getUserCompany().then(() => {
      company = $rootScope.oUserCompany.id
    })

    $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      $scope.features = features
    })

    api._keepOnSamePage($state.params)
    api._getPostsCategories()

    $rootScope.getUser().then((user) => {
      api._initHeader(user)
    })
  }

  $scope.handleNewPostClick = handleNewPostClick

  function _onFilter (filters, hasPreFilters) {
    if (hasPreFilters) {
      return
    }

    $scope.filters = filters
    $scope.update()
  }

  function _onSearch (search) {
    $scope.search = search
    $scope.update()
  }

  function _getHeaderRightButtons () {
    const buttonsForAdminOrDesigner = [{
      type: 'analytics',
      module: 'announcements'
    }, {
      type: 'button',
      btnType: 'primary',
      label: $translate.instant('add'),
      icon: 'plus',
      onClick: handleNewPostClick
    }]

    if (isAdminOrDesigner) { return buttonsForAdminOrDesigner }
    return []
  }

  function _successGetPosts (isPinnedPosts, oRes) {
    if (isPinnedPosts) {
      $scope.pinnedPosts = oRes.rows
    } else {
      $scope.aPosts = oRes.rows
      $scope.iPostsCount = oRes.count
    }
    $scope.noPinnedPosts = Boolean(!$scope.pinnedPosts.length)
    api._checkIfPageExists($scope.iPostsCount, $scope.iCurrentTop)
    $scope.flags.bLoading = false
  }

  function _successGetCategories (oRes) {
    $scope.categories = oRes
    $scope.flags.bLoading = false
  }

  function _handleError () {
    if (!$rootScope.oUser) {
      return
    }
    ToastService.defaultErrorToast()
  }

  function populateParentArray (array, category) {
    if (category.parent && category.parent.id) {
      array.push({ name: category.parent.name, id: category.parent.id })
      populateParentArray(array, category.parent)
    } else {
      array.reverse()
    }
  }

  function _successGetParentForCategory (oRes) {
    $scope.flags.bLoading = false
    $scope.pathCategory = []
    populateParentArray($scope.pathCategory, angular.copy(oRes))
    $scope.pathCategory.push({ name: oRes.name, id: oRes.id })
  }

  function getParentForCategory (category) {
    $scope.flags.bLoading = true
    PostsService.getPostCategoryParented(category.id).then(api._successGetParentForCategory)
  }

  function _getPostsCategories () {
    $scope.flags.bLoading = true
    PostsService.getPostCategoriesParentless().then(api._successGetCategories).catch(api._handleError)
  }

  function skipPagingTo (iToken, fromParams) {
    $scope.iToken = iToken

    let pageToken = Number(iToken)

    if (!fromParams || !pageToken) {
      pageToken = isNaN(pageToken) ? 1 : pageToken + 1
    }

    if (pageToken < 1) {
      pageToken = 1
    }

    $scope.indexToken = pageToken - 1
    $scope.currentPage = pageToken - 1

    const page = pageToken !== 1 ? pageToken : null

    $location.search({ ...$state.params, page })

    const iSkip = pageToken - 1

    const params = {
      currentTop: $scope.iCurrentTop,
      token: iSkip,
      isPinned: false
    }
    const normalPostsPromise = api._getPosts(params)
    const pinnedPostsPromise = api._getPosts({
      isPinned: true
    })

    $q.all([normalPostsPromise, pinnedPostsPromise])
      .then(([normalPosts, pinnedPosts]) => {
        api._successGetPosts(false, normalPosts)
        api._successGetPosts(true, pinnedPosts)
      })
      .catch(ToastService.defaultErrorToast)
  }

  function _keepOnSamePage (stateParams) {
    if (stateParams.page) {
      skipPagingTo(stateParams.page, true)
    } else {
      skipPagingTo(0)
    }
  }

  function _checkIfPageExists (count, top) {
    const paginationSize = Math.ceil(count / top)

    if ($scope.currentPage > paginationSize) {
      skipPagingTo(1, true)
      ToastService.showErrorToast($translate.instant('thisPageDoesNotExist'))
    }
  }

  function _getPosts (params) {
    $scope.flags.bLoading = true
    const { currentTop = 10, token = 0, isPinned = false } = params
    return PostsService.getPosts(currentTop, currentTop * token, {
      ...$scope.filters,
      term: $scope.search,
      isPinned
    })
  }

  function handleNewPostClick () {
    $('.sidebar-menu-second-level').transition('slide down')
    if ($rootScope.isDesktop) {
      ModalService.showModal({
        templateId: 'newPost.html',
        templateUrl: '/posts/dialogs/post/post-dialog.html?$$REVISION$$',
        destroyable: true,
        data: {
          _editMode: true
        }
      }).then(function () {
        $scope.skipPagingTo(0)
      })
    } else {
      SliderService.setState('post-slider', 'open', {
        _editMode: true,
        _existingPost: false
      })
    }
  }

  $scope.onPinnedPostChange = function (post) {
    if (post.isPinned) {
      const index = $scope.aPosts.findIndex(item => item.id === post.id)
      $scope.aPosts.splice(index, 1)
      $scope.pinnedPosts.push(post)
    } else {
      const index = $scope.pinnedPosts.findIndex(item => item.id === post.id)
      $scope.pinnedPosts.splice(index, 1)
      $scope.flags.bLoading = true
      api._getPosts({
        currentTop: $scope.iCurrentTop,
        token: 0,
        isPinned: false
      })
        .then(api._successGetPosts.bind(this, false))
        .catch(ToastService.defaultErrorToast)
    }

    $scope.noPinnedPosts = Boolean(!$scope.pinnedPosts.length)
    if (!$scope.$$phase) {
      $scope.$apply()
    }
  }

  $scope.update = function () {
    skipPagingTo(0)
  }

  $scope.clearFilters = function (sFilterProperty) {
    $scope.selectedCategory = undefined
    if (!sFilterProperty || typeof sFilterProperty === 'undefined') {
      $scope.filters = {}
      $scope.pathCategory = []
    } else if (sFilterProperty === 'categoryId') {
      $scope.filters.categoryId = null
      $scope.pathCategory = []
    } else {
      $scope.filters[sFilterProperty] = null
    }
    $scope.isArchived = false
    $scope.update()
  }

  $scope.onComplete = function (paging) {
    if ($stateParams.page && $scope.aPosts.length > 1) {
      paging = paging || $stateParams.page
      $scope.skipPagingTo(paging, true)
    } else {
      $scope.skipPagingTo(0)
    }
  }

  $scope.onChange = function (category) {
    if (category && $scope.selectedCategory !== category.id) {
      $scope.selectedCategory = category.id
      getParentForCategory(category)
      const categoryId = category.id
      $scope.filters.categoryId = categoryId
      $scope.update()
    }
  }

  $scope.seePostDetails = function (post, _openResults) {
    if ($rootScope.isDesktop && post.id) {
      $location.search({ company, post: post.id })

      if (_openResults) {
        SegmentService.track('announcement-list-results-btn')

        if (window.clarity) {
          window.clarity('set', 'announcement-list-results-btn', null)
        }
      }

      ModalService.showModal({
        templateId: 'newPost.html',
        templateUrl: '/posts/dialogs/post/post-dialog.html?$$REVISION$$',
        destroyable: true,
        closable: true,
        data: {
          _postId: post.id,
          _editMode: false,
          _openResults
        }
      }).then(function (hasUpdatedPost) {
        $location.search({ page: $scope.currentPage + 1 })

        if (hasUpdatedPost) {
          $scope.onComplete($scope.iToken)
          return
        }

        api._changeUnreadFlag(post.id)
      })
    }
  }

  function _changeUnreadFlag (postId) {
    const idPostSelected = post => post.id === postId
    const postSelected = $scope.aPosts.find(idPostSelected) || $scope.pinnedPosts.find(idPostSelected)

    if (postSelected.unread) {
      postSelected.unread = false
    }
  }

  $scope.onSeeAnalyticsResultsByPostCategory = (paths) => {
    const lastIndex = paths.length - 1
    const selectedCategory = paths[lastIndex]

    const analyticsState = 'analytics.dashboard'
    const routeParams = {
      slug: 'announcements-overview',
      filterName: 'POSTS_CATEGORIES',
      filterValue: selectedCategory
    }

    SegmentService.track('announcement-tag-analytics-btn')

    if (window.clarity) {
      window.clarity('set', 'announcement-tag-analytics-btn', null)
    }

    $state.go(analyticsState, routeParams)
  }

  function _initHeader (user) {
    $scope.pageTitle = $translate.instant('posts')

    const exhibitDefaultValue = {
      label: $translate.instant('actives'),
      value: false,
      icon: 'success',
      active: true,
      disabled: false
    }

    const filters = [
      {
        name: 'isArchived',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: exhibitDefaultValue,
        props: {
          label: $translate.instant('exhibit'),
          multiple: false,
          switchMode: true,
          udsDisabled: false,
          options: [
            exhibitDefaultValue,
            {
              label: $translate.instant('archivedPlural'),
              value: true,
              icon: 'archive',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'read',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: null,
        props: {
          label: $translate.instant('type'),
          multiple: false,
          switchMode: false,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('read'),
              value: true,
              icon: 'conforming-form',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('unread'),
              value: false,
              icon: 'nonconforming-form',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'categoryId',
        type: 'INPUT_MULTISELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('category'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'tag',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (search, top, skip) => PostsService.getPostCategories(search, top, skip)
      },
      {
        name: 'authorId',
        type: 'INPUT_MULTISELECT',
        grouped: true,
        defaultValue: [],
        props: {
          label: $translate.instant('creator'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'user',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (search, top, skip) => AdminService.filterUsers(top, skip, { search })
      },
      {
        name: 'score',
        type: 'INPUT_MULTISELECT',
        grouped: true,
        defaultValue: [],
        props: {
          label: $translate.instant('score'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'text',
          hasMoreOptions: false,
          udsDisabled: false,
          options: Utils.createScoreArray(5)
        }
      },
      {
        name: 'createdAt',
        type: 'DATE_PICKER',
        grouped: true,
        defaultValue: '',
        props: {
          locale: user.locale,
          label: $translate.instant('creationDate'),
          firstDayOfWeek: '1',
          direction: 'right'
        }
      },
      {
        name: 'expiredAt',
        type: 'DATE_PICKER',
        grouped: true,
        defaultValue: '',
        props: {
          locale: user.locale,
          label: $translate.instant('expiration'),
          firstDayOfWeek: '1',
          direction: 'right'
        }
      }
    ]

    $scope.headerToolbar = {
      rightButtons: api._getHeaderRightButtons(),
      search: {
        filters,
        onFilter: api._onFilter,
        onSearch: api._onSearch
      }
    }
  }
}

export { PostsController }
